import { render, staticRenderFns } from "./ExpirationDateCard.vue?vue&type=template&id=42915ae6&scoped=true"
import script from "./ExpirationDateCard.vue?vue&type=script&lang=js"
export * from "./ExpirationDateCard.vue?vue&type=script&lang=js"
import style0 from "./ExpirationDateCard.vue?vue&type=style&index=0&id=42915ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42915ae6",
  null
  
)

export default component.exports